function Submit({buttonText, loading}:any) {
  return (    
     <button type="submit" className='submit mt-3' disabled={loading}>
        {loading ? 
        (
            <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>Please wait...
            </>
        ):(
            <>{buttonText}</>
        )}
    </button> 
  );
};

export default Submit;